$(".btn-addPrinter").click(function() {
    $(".my-printer-warp .myPrinter").hide();
    $(".my-printer-warp .add-printer").show();
     $(".my-printer-warp .my-printer-nav span").eq(1).addClass("my-printer-nav-on").siblings().removeClass("my-printer-nav-on");
});
$(".my-printer-warp .my-printer-nav span").click(function() {
    $(this).addClass("my-printer-nav-on").siblings().removeClass("my-printer-nav-on");
    var index = $(this).index();
    if (index == 0) {
        $(".my-printer-warp .myPrinter").show();
        $(".my-printer-warp .add-printer").hide()
    } else {
        $(".my-printer-warp .myPrinter").hide();
        $(".my-printer-warp .add-printer").show()
    }
});
function getMyPrinter() {
    var myPrinter = [];
    if (localStorage.myPrinter) {
        myPrinter = JSON.parse(localStorage.myPrinter)
    }
    var template0 = $("#myPrinter-item-template").html();
    var template = "";
    $.each(myPrinter,
    function(key, val) {
        var template1 = template0;
        template1 = template1.replace(/hreft/g, "href");
        template1 = template1.replace(/{printer.title}/g, val["model"]);
        template1 = template1.replace(/{printer.brand}/g, val["brand"]);
        template1 = template1.replace(/{printer.url}/g, val["url"]);
        template += template1
    });
    if (template) {
        $("#myPrinter-item").html(template)
    }
    $("#myPrinter-item").show()
}
getMyPrinter();
$(".icon-subtract").click(function() {
    var title = $(this).attr("title");
    layer.confirm("Are you sure you want to delete this " + title + " from My Printers?：", {
        btn: ["Remove ", "Cancel "],
        title: "message",
    },
    function() {
        layer.msg("SUCCEED", {
            icon: 1
        });
        var myPrinter0 = {};
        if (localStorage.myPrinter) {
            myPrinter0 = JSON.parse(localStorage.myPrinter)
        }
        var myPrinter = {};
        $.each(myPrinter0,
        function(key, val) {
            if (key != title) {
                myPrinter[key] = val
            }
        });
        localStorage.myPrinter = JSON.stringify(myPrinter);
        window.location.reload()
    },
    function() {});
    return false
});
$(".brand-item,.series-item").hover(function() {
    $(this).addClass("printer-item-hover")
},
function() {
    $(this).removeClass("printer-item-hover")
});
$(".brand-item").click(function() {
    $(".brand-item").removeClass("printer-item-on");
    $(".series-item").removeClass("printer-item-on");
    $(this).addClass("printer-item-on");
    var brand = $(this).attr("brand");
    $(".series-" + brand).css("display", "flex");
    $(".series-" + brand).siblings().hide();
    $(".product .add-printer-list").hide()
});
$(".series-item").click(function() {
    $(".series-item").removeClass("printer-item-on");
    $(".product-item").removeClass("printer-item-on");
    $(this).addClass("printer-item-on");
    var series = $(this).attr("series");
    var brand = $(this).attr("brand");
    $(".product-" + brand + "-" + series).css("display", "flex");
    $(".product-" + brand + "-" + series).siblings().hide()
});
$(".product-item").click(function() {
    $(this).toggleClass("printer-item-on")
});
$("#submit").click(function() {
    var myPrinter = {};
    if (localStorage.myPrinter) {
        myPrinter = JSON.parse(localStorage.myPrinter)
    }
    var LayerStr = "";
    $(".product .printer-item-on").each(function() {
        var str = "";
        var brand = $(this).attr("brand");
        var printer = $(this).attr("printer");
        var url = $(this).attr("url");
        str = printer + "（" + brand + "）";
        if (LayerStr) {
            LayerStr += "；"
        }
        LayerStr += str;
        myPrinter[str] = {
            "model": printer,
            "brand": brand,
            "url": url
        }
    });
    if(!LayerStr){
       layer.open({
          title: 'information',
          shadeClose: true, //开启遮罩关闭
          btn: ['confirm'], //按钮
          skin: 'layui-layer-rim', //加上边框
          content: '<div class="layer-code">Select a PRINTER</div>'
        });
		return false;
    }
    layer.confirm("Save to My Printers：" + LayerStr, {
        shadeClose: true, //开启遮罩关闭
        btn: ["Add ", "Cancel "],
        title: "message",
    },
    function() {
        layer.msg("SUCCEED", {
            icon: 1
        });
        localStorage.myPrinter = JSON.stringify(myPrinter);
        window.location.reload()
    },
    function() {})
});
$("#add-printer-c").click(function() {});